/**
 * apidfe.js — cliente axios para o serviço DFe (gnre/danfe)
 * Porta 5002 — separado do apinode (porta 4007)
 *
 * Uso:
 *   import apidfe from '../../services/apidfe.js'
 *   apidfe.get('/gnre/consultar-nfe/514066249/123')
 */

import axios from 'axios'

const apidfe = axios.create({
  baseURL: 'https://node.ziphub.com.br',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
})


export default apidfe